<script>
import { Bar } from 'vue-chartjs'
import moment from "moment";

export default {
    extends: Bar,

    data: () => ({
        loading: false,
        chartData: {
            labels: [],
            datasets: []
        },
        options: {
            responsive: true,
            maintainAspectRatio: false
        },

        colors: [
            '#4dc9f6',
            '#f67019',
            '#f53794',
            '#537bc4',
            '#acc236',
            '#166a8f',
            '#00a950',
            '#58595b',
            '#8549ba'
        ]
    }),


    async mounted () {
        try {
            await this.load()
        } catch (e) {

        }
    },

    methods: {
        async load() {
            this.loading = true

            try {
                const { data } = await axios.get(`/reports/dashboard/delivery-monthly`)

                const itemsGroupedByMonth = _.groupBy(data.data, 'month');

                const months = _.sortBy(Object.keys(_.groupBy(data.data, 'month')), (month) => {
                    return parseInt(moment(month+'-01').format('X'))
                })

                const deliveryStatuses = Object.keys(_.groupBy(data.data, 'current_delivery_status'))

                this.chartData.datasets = deliveryStatuses.map((status, index) => {
                    if (status === 'null') {
                        status = 'ไม่มีข้อมูล'
                    }

                    return {
                        label: status,
                        backgroundColor: this.colors[index],
                        data: months.map((month) => {
                            const items = itemsGroupedByMonth[month] || []
                            return _.sumBy(items.filter(item => item.current_delivery_status === status), 'total')
                        })
                    }
                })

                this.chartData.labels = months.map((month) => {
                    return moment(month+'-01').format('MMMM YY')
                });

                this.renderChart(this.chartData, this.options)

            } catch (e) {
                console.log(e)
            }

            this.loading = false
        }
    }
}
</script>
